<template>
  <div class="c-candle">
    <span class="sr-only">{{ $t('white-label.components.candle.relativeRangeGraphic') }}</span>
    <div class="c-candle__container" v-if="dataValid">
      <div class="c-candle__bg" />
      <div class="c-candle__indicator" :class="`c-candle__indicator--${indicator}`" :style="style" />
    </div>
    <p v-else v-text="$t('white-label.components.candle.missingData')" />
  </div>
</template>

<script>
export default {
  name: 'c-candle',
  props: {
    open: {
      type: Number,
      required: true
    },
    close: {
      type: Number,
      required: true
    },
    high: {
      type: Number,
      required: true
    },
    low: {
      type: Number,
      required: true
    }
  },
  computed: {
    dataValid() {
      return this.open !== 0 && this.close !== 0 && this.high !== 0 && this.low !== 0;
    },
    indicator() {
      return this.open < this.close ? 'positive' : 'negative';
    },
    total() {
      return this.high - this.low;
    },
    left() {
      return ((this.indicator === 'positive' ? this.open - this.low : this.close - this.low) * 100) / this.total;
    },
    width() {
      return ((this.indicator === 'positive' ? this.close - this.open : this.open - this.close) * 100) / this.total;
    },
    style() {
      return {
        left: `${this.left}%`,
        width: `${this.width}%`
      };
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-candle';
</style>
